@let hasShiftUpdatePermissions =
  can(RoleAction.Update, RolePermissionSubject.Shift);
@let hasServiceUpdatePermissions =
  can(RoleAction.Update, RolePermissionSubject.Service);
@let hasUpdatePermission =
  activity.serviceId ? hasServiceUpdatePermissions : hasShiftUpdatePermissions;
@let isAdminUser = !!(isAdminUser$ | async);

<div class="mt-4">
  @if (activity.createdFrom !== WilsonApp.Mobile) {
    <button
      [disabled]="!hasUpdatePermission || isAllDisabled"
      nz-button
      class="w-100 fw-normal mb-2"
      nz-tooltip
      [nzTooltipTitle]="
        !hasUpdatePermission ? ('general.forbidden_action' | translate) : ''
      "
      (click)="openSplitActivityPopup()"
    >
      <fa-icon [icon]="faScissors" class="me-2"></fa-icon>
      {{ 'activity.split_activity' | translate }}
    </button>
  }

  <div>
    @if (isLastActivityInShift) {
      <nz-alert
        nzType="warning"
        class="mb-2 warning-alert"
        [nzMessage]="
          'page.shift_timeline.drawer.activity_form.also_delete_shift'
            | translate
        "
        nzShowIcon
      ></nz-alert>
    }
    <!-- TODO: add this back after BE support activity report deletion in single endpoint - https://menlo1679.atlassian.net/browse/WILP-7918 -->
    <!-- @let isDeleteActivityDisabled = !hasUpdatePermission || isAllDisabled ||
    (isShiftStartedSignal() && !isShiftSubmittedSignal()) ||
    (isShiftSubmittedSignal() && !isAdminUser); -->
    @let isDeleteActivityDisabled =
      !hasUpdatePermission ||
      isAllDisabled ||
      (isShiftStartedSignal() && !isShiftSubmittedSignal()) ||
      isShiftSubmittedSignal();
    <button
      [disabled]="isDeleteActivityDisabled"
      nz-button
      class="w-100 fw-normal"
      (click)="delete.emit()"
      nz-tooltip
      [nzTooltipTitle]="
        {
          hasUpdatePermission,
          isShiftStarted: isShiftStartedSignal(),
          isShiftSubmitted: isShiftSubmittedSignal(),
          isAdminUser,
        } | activityDrawerDeleteForbiddenMessage
      "
    >
      <fa-icon [icon]="faTrashAlt" class="me-2"></fa-icon>
      {{
        activity.serviceId
          ? ('page.shift_timeline.drawer.activity_form.remove_activity_from_shift'
            | translate)
          : ('page.shift_timeline.drawer.activity_form.delete_activity'
            | translate)
      }}
    </button>
  </div>
</div>
